// extracted by mini-css-extract-plugin
export default {"blurBackground":"styles_blurBackground__w6K7t"};